import { render, staticRenderFns } from "./online-navigation-configuration.vue?vue&type=template&id=585b74ee&"
import script from "./online-navigation-configuration.vue?vue&type=script&lang=ts&"
export * from "./online-navigation-configuration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports